import { render, staticRenderFns } from "./FacSemCorretorDashboardComponent.vue?vue&type=template&id=4185a7d5"
import script from "./FacSemCorretorDashboardComponent.vue?vue&type=script&lang=js"
export * from "./FacSemCorretorDashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports